import PendingIndex from "../Components/PendingIndex";


function Pending() {
    return (
        <PendingIndex />
    );
}

export default Pending;